import { render, staticRenderFns } from "./ShippedByFNS-Stacked.vue?vue&type=template&id=68349302&"
import script from "./ShippedByFNS-Stacked.vue?vue&type=script&lang=js&"
export * from "./ShippedByFNS-Stacked.vue?vue&type=script&lang=js&"
import style0 from "./ShippedByFNS-Stacked.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports